import { Resource, Item } from './genericTypes';

export type ConnectMutationVariables = Object | null;

export function computeConnectMutationVariables(
  item: Item,
  resourceConfig: Resource,
): ConnectMutationVariables {
  return {
    [resourceConfig.keyProperty]: item[resourceConfig.keyProperty],
  };
}
